export default __webpack_public_path__ + "static/media/carousel_shadow.15e8cb4b.png";